// extracted by mini-css-extract-plugin
export var container = "_bx-0";